import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { Tabs, Tab } from "@material-ui/core";
import IdentifierSection from "./identifier_section";
import { DuplicateSection, MailRoutingSection, MetadataSection } from "./sections";
import RuleList from "./rule_list";
import RawJsonEditor from "./raw_rule_editor";
import { collectKnownColumns, configModelToJsonView, jsonViewToConfigModel } from "./config_model";

const ConfigEditor = ({ config, onChange, defaultFormId }) => {
  const [tab, setTab] = useState(0);
  const knownColumns = collectKnownColumns(config);

  return (
    <div>
      <Row noGutters className="border-bottom mb-3 align-items-center">
        <Col>
          <Tabs value={tab} onChange={(e, v) => setTab(v)} indicatorColor="primary" textColor="primary">
            <Tab label="Simple View" />
            <Tab label="JSON View" />
          </Tabs>
        </Col>
      </Row>

      {tab === 0 ? (
        <div>
          <IdentifierSection config={config} onChange={onChange} />
          <DuplicateSection config={config} onChange={onChange} knownColumns={knownColumns} />
          <MailRoutingSection config={config} onChange={onChange} defaultFormId={defaultFormId} />
          <RuleList rules={config.rules} onChange={rules => onChange({ ...config, rules })} knownColumns={knownColumns} />
          <MetadataSection config={config} />
        </div>
      ) : (
        <div>
          <div className="small text-muted mb-2">This reflects the same configuration as Simple View. Edits here apply on blur once the JSON is valid.</div>
          <RawJsonEditor
            value={configModelToJsonView(config)}
            onApply={parsed => onChange(jsonViewToConfigModel(parsed, config))}
            minRows={22}
          />
        </div>
      )}
    </div>
  );
};

export default ConfigEditor;
